import { CheckableGroupContext } from "./chunk-YG26ROD3.js";
import { LinkAsButton_default } from "./chunk-4QQB43WX.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckableGroup/CheckableGroup.MoreButton.tsx
import { forwardRef, useCallback, useContext } from "react";
import clsx from "clsx";
import { jsxs } from "react/jsx-runtime";
var CheckableGroupMoreButton = forwardRef((_a, ref) => {
  var _b = _a,
    {
      className,
      onClick,
      children
    } = _b,
    rest = __objRest(_b, ["className", "onClick", "children"]);
  const {
    setIsExpanded,
    totalItems,
    maxItems
  } = useContext(CheckableGroupContext);
  const handleClick = useCallback(event => {
    setIsExpanded(true);
    onClick == null ? void 0 : onClick(event);
  }, [setIsExpanded, onClick]);
  return /* @__PURE__ */jsxs(LinkAsButton_default, __spreadProps(__spreadValues({}, rest), {
    ref,
    type: "button",
    onClick: handleClick,
    className: clsx("pd:checkable-group__more-button", className),
    iconBefore: "arrow-down",
    children: [children, /* @__PURE__ */jsxs("span", {
      children: ["(+", totalItems - maxItems, ")"]
    })]
  }));
});
var CheckableGroup_MoreButton_default = CheckableGroupMoreButton;
export { CheckableGroup_MoreButton_default };